import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from '@custom-components';
import { strSortFn, valSortFn, userShape } from '../helperFunctions';
import UserTable from './UserTable';
import UserContainer from './UserContainer';

import List from '../List';

const userViewFilters = [
  {
    id: 'ALL_USERS_VIEW',
    label: 'All Users',
    filterFn: () => true
  },
  {
    id: 'CUSTOMER_USERS',
    label: 'Has Customer Org',
    filterFn: (item) => item.customers.length !== 0
  },
  {
    id: 'SUPPLIERS_USERS',
    label: 'Has Supplier Org',
    filterFn: (item) => item.suppliers.length !== 0
  }
];

const userSortFilters = [
  {
    id: 'USER_NAME_SORT',
    label: 'First Name (asc)',
    sortFn: (a, b) => strSortFn(a, b, 'firstName')
  },
  {
    id: 'USER_NAME_SORT_DESC',
    label: 'First Name (desc)',
    sortFn: (a, b) => strSortFn(a, b, 'firstName', 'desc')
  },
  {
    id: 'USER_LNAME_SORT',
    label: 'Last Name (asc)',
    sortFn: (a, b) => strSortFn(a, b, 'lastName')
  },
  {
    id: 'USER_LNAME_SORT_DESC',
    label: 'Last Name (desc)',
    sortFn: (a, b) => strSortFn(a, b, 'lastName', 'desc')
  },
  {
    id: 'RECENT_JOINED',
    label: 'Joined Recently',
    sortFn: (a, b) => valSortFn(a, b, 'id', 'desc')
  },
  {
    id: 'RECENT_LOGIN',
    label: 'Logged In Recently',
    sortFn: (a, b) => valSortFn(a, b, 'lastLogin', 'desc')
  }
];

function UserList(props) {
  const { allUsers, loading, error } = props;
  return (
    <Grid.ScreenClassRender
      render={(screenClass) => (
        <UserContainer>
          {({
            pagination,
            search,
            sortBy,
            toggle,
            view,
            updatePagination,
            updateSearch,
            updateSortBy,
            updateToggle,
            updateView
          }) => (
            <List
              initialPaginationValue={pagination}
              initialQueryValue={search}
              initialSortFilterId={sortBy}
              initialToggleValue={toggle}
              initialViewFilterId={view}
              data={allUsers}
              loading={loading}
              error={error}
              viewFilters={userViewFilters}
              sortFilters={userSortFilters}
              screenClass={screenClass}
              tableComponent={UserTable}
              helpText="Search by name, email or current organization"
              noDataObj={{
                message: 'There are no users for that search, or no users have been created',
                title: 'No Users'
              }}
              searchBy={['firstName', 'lastName', 'emailAddress', 'currentOrgName']}
              listComponentProps={{
                defaultView: 'tableView',
                interactionHooks: {
                  onPaginationChange: (p) => updatePagination(p),
                  onSearchChange: (s) => updateSearch(s),
                  onSortFilterClick: (s) => updateSortBy(s.id),
                  onViewFilterClick: (v) => updateView(v.id),
                  onViewToggleClick: (t) => updateToggle(t)
                }
              }}
            />
          )}
        </UserContainer>
      )}
    />
  );
}

UserList.propTypes = {
  allUsers: PropTypes.arrayOf(userShape).isRequired,
  loading: PropTypes.bool,
  error: PropTypes.shape({})
};

UserList.defaultProps = {
  loading: true,
  error: null
};

export default UserList;
